import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TourFormData } from '@/features/dashboard/tourConfig/schemas/tourSchema.ts';
import { toast } from 'sonner';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourDto from '@/features/dashboard/tourConfig/types/TourDto.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { tourDtoMapper } from '@/features/dashboard/tourConfig/types/TourDto.mapper.ts';

const useUpdateTour = () => {
  const queryClient = useQueryClient();

  return useMutation<TourDto, Error, { tourId: string; data: TourFormData }>({
    mutationFn: ({ tourId, data }) => {
      const tourDto = tourDtoMapper.fromFormToDto(data);
      return toursApi.updateTour(tourId, tourDto);
    },
    onSuccess: (tour) => {
      toast.success('Wyjazd został zaktualizowany');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
      if (tour.id) {
        queryClient.invalidateQueries({
          queryKey: toursApiQueryKeys.byId(tour.id),
        });
      }
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zaktualizować wyjazdu', {
        description: error.message,
      });
    },
  });
};

export default useUpdateTour;
